import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function WritingStrand({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-8 -2 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g
        className={theme.stroke}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M6.69986154 13.2173333H17.4460154l5.3193461 7.5685679-10.664923 14.1901729L1.38093846 20.7859012z" />
        <path d="M14.3573846 20.3379827c0 1.2517037-1.0225769 2.2662469-2.2841923 2.2662469-1.26203845 0-2.28461538-1.0145432-2.28461538-2.2662469s1.02257693-2.2662469 2.28461538-2.2662469c1.2616154 0 2.2841923 1.0145432 2.2841923 2.2662469zM12.0729808 34.6087901V22.6042716M21.8132692 1.37777778H2.33269231L6.555 13.2823951h11.0363846z" />
      </g>
    </svg>
  )
}

WritingStrand.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
